import store from './index';
import { resetWorkflow } from './workflow/workflowSlice';
import { resetProjectState } from './project/projectSlice';

export const resetAllStores = () => {
  store.dispatch(resetWorkflow());
  store.dispatch(resetProjectState());
};

export const resetStore = resetAllStores; 